module.exports = __webpack_public_path__ + "img/CRam64_ua.15df4cc4.webp";